import { RouteName } from '@/User/Constants/routes';
import { Link } from "@inertiajs/react";
import React from "react";
import { twMerge } from 'tailwind-merge';
import route from 'ziggy-js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const JobOfferCard = ({ jobOffer, isNew = false, className = '', classImgItem = '', footerButtons = null }) => {
    const extraClass = 'w-16 text-center text-sm leading-4 text-primary font-semibold px-1 py-0.5 bg-alice-blue-3';
    const infoClass = 'text-sm leading-none text-midnight font-light';

    return (
        <div className={twMerge(`bg-white shadow-lg rounded p-2 w-full h-max relative flex flex-col justify-between ${className}`)}>
            <Link href={route(RouteName.JobOfferDetailPage, { id: jobOffer.id })}
                className="inline-flex flex-col gap-2 grow">
                {isNew && (
                    <span className="inline-block z-10">
                        <span className="absolute text-center top-0 left-2 bg-lemon text-primary text-1.5xs font-semibold w-8 py-2">NEW</span>
                        <span className="absolute top-8 left-2 border-x-16 border-b-8 border-b-transparent border-lemon"></span>
                    </span>
                )}
                <LazyLoadImage
                    src={jobOffer.main_image}
                    alt={jobOffer?.franchise?.franchise_name ?? ''}
                    className={`h-26.5 max-w-full object-contain ${classImgItem}`}
                />
                <h4 className="font-semibold text-sm leading-4.5 text-midnight h-9 break-all line-clamp-2">{jobOffer?.franchise?.franchise_name ?? ''}</h4>
                <p className="font-light text-sm leading-4.5 text-midnight h-13.5 break-all line-clamp-3">{jobOffer.catch_copy ?? ''}</p>
                <div className="flex flex-col min-h-20 gap-1">
                    {jobOffer.industry_label !== '' && (
                        <div className="flex gap-2 items-center min-h-7">
                            <span className={extraClass}>業種</span>
                            <span className={infoClass}>{jobOffer.industry_label}</span>
                        </div>
                    )}
                    {jobOffer.total_opening_with_currency !== '' && (
                        <div className="flex gap-2 mb-1">
                            <span className={extraClass}>開業資金</span>
                            <span className={infoClass}>{jobOffer.total_opening_with_currency}</span>
                        </div>
                    )}
                    {jobOffer.target_label !== '' && (
                        <div className="flex gap-2">
                            <span className={extraClass}>対象</span>
                            <span className={infoClass}>{jobOffer.target_label}</span>
                        </div>
                    )}
                </div>
            </Link>
            {footerButtons}
        </div>
    );
};

export default JobOfferCard;
